import { axiosApi } from "../../../../../api/dbAxios";

export const createDraftForm = async (form: any, files: File[] = []) => {
  const test_email = "rborodinov@deloittece.com";
  const isLocalhost =
    typeof window !== "undefined" && window.location.hostname === "localhost";

  const filesToSend = files;
  const extractVal = (x: any) =>
    x && typeof x === "object" && "value" in x ? x.value : x;

  const formData = new FormData();
  Object.entries(form || {}).forEach(([key, value]) => {
    if (value == null) return;
    if (Array.isArray(value))
      value.forEach((item) => {
        const v = extractVal(item);
        if (v != null && v !== "") formData.append(key, String(v));
      });
    else {
      const v = extractVal(value);
      if (v != null && v !== "") formData.append(key, String(v));
    }
  });
  filesToSend.forEach((file) => formData.append("files", file));
  if (isLocalhost) formData.append("test_email", test_email);

  try {
    const response = await axiosApi.post(`/add_record/`, formData);
    return response.data;
  } catch (error: any) {
    const respData = error?.response?.data;
    let msg: any;
    if (typeof respData === "string") {
      let s = respData.trim();
      const xssi = ")]}'";
      if (s.startsWith(xssi)) {
        s = s.slice(xssi.length).trim();
        if (s.startsWith(",")) s = s.slice(1).trim();
      }
      try {
        const p = JSON.parse(s);
        msg = p?.files ?? p?.message ?? s;
      } catch {
        msg = s;
      }
    } else if (respData && typeof respData === "object") {
      msg = respData.files ?? respData.message ?? respData;
    } else {
      msg = error?.message ?? String(error);
    }
    throw msg;
  }
};
